module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"AdminSection":"Area Admin","SystemAdmin":"System Admin","UserManagement":"Gestione Utenti","support":"Assistenza","PatientSection":"Area Personale","NutritionistSection":"Area Nutrizionista","profile":"I tuoi Dati"}}')
  delete Component.options._Ctor
}
